/**
 * Reveals section-level headings (one main title per section, not repeated
 * card/product/form titles) with a "float up into place" animation the first
 * time they scroll into view. Runs once per heading (unobserved after reveal).
 */
(function () {
  var SECTION_HEADING_SELECTOR = [
    '.neon-labs-hero-heading',
    '.nl-about-heading',
    '.neon-col-main-title',
    '.neon-labs-custom-quote-wrap .headline',
    '.neon-labs-faq-title',
    '.neon-labs-critics-title',
    '.neon-labs-reviews-heading',
    '.neon-hq-title',
    '.nl-fq-headline',
    '.neon-hiw2-title',
    '.neon-hiw-title',
    '.nl-guarantee-main-heading',
    '.nl-inc-heading',
    '.nl-inck-heading',
    '.nl-trust-main-heading',
    '.neon-labs-looking-heading',
    '.nl-wyg-heading',
  ].join(', ');

  var headings = document.querySelectorAll(SECTION_HEADING_SELECTOR);
  if (!headings.length) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('neon-labs-heading-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  headings.forEach(function (el) {
    el.classList.add('neon-labs-heading-reveal');
    observer.observe(el);
  });
})();
